import { PatientTabProps } from '~/lib/constants/patients.constants';

import PatientDocumentsV2 from './patient-document-V2';

const PatientDocumentsTab = ({ patientId }: PatientTabProps) => {
  return <PatientDocumentsV2 patientId={patientId} />;
};

export default PatientDocumentsTab;
